// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","body":"G6MfM4jL","expand":"_9tQHaEC5","rich-text":"_3XeX4w7Q pt1","richText":"_3XeX4w7Q pt1"};